




































import { defineComponent } from "@vue/composition-api";
import BaseIconButton from "@/components/BaseIconButton";
import BaseImage from "@/components/BaseImage";
import BaseSpinner from "@/components/BaseSpinner";

export default defineComponent({
  name: "ImagePreview",
  components: { BaseIconButton, BaseImage, BaseSpinner },
  props: {
    size: { type: Number },
    src: { type: String, required: true },
    alt: { type: String },
    loading: { type: Boolean, default: false },
    remove: { type: Boolean, default: false },
  },
});
